const { optimaConfigConstants } = require('./optima');

// this file is to just support legacy code reference actual constants moved to packages/constant
module.exports = {
  algorithm_type: optimaConfigConstants.algorithmType,
  algorithm_type_map: optimaConfigConstants.algorithmTypeMap,
  optima_type: optimaConfigConstants.optimaType,
  optimaTypeMap: optimaConfigConstants.optimaTypeMap,
  optima_status: optimaConfigConstants.optimaStatus,
  erp_status: optimaConfigConstants.erpStatus,
  FrequencyType: optimaConfigConstants.FrequencyType,
  pickupThreshold: optimaConfigConstants.pickupThreshold,
  floorOne: optimaConfigConstants.floorOne,
  floorTwo: optimaConfigConstants.floorTwo,
};
